// playerService.js

class PlayerService {
  constructor(songs) {
    this.songs = songs;
    this.audio = new Audio(songs[0].file);
    this.currentIndex = 0;
    this.isPlaying = false;
    this.onUpdate = null; // callback for UI update
    this.audio.addEventListener('ended', this.next.bind(this));
    this.audio.addEventListener('timeupdate', () => this._notify());
    this.audio.addEventListener('loadedmetadata', () => this._notify());
  }

  _notify() {
    if (this.onUpdate) {
      this.onUpdate(this.getState());
    }
  }

  setUpdateCallback(cb) {
    this.onUpdate = cb;
  }

  play() {
    this.audio.play();
    this.isPlaying = true;
    this._notify();
  }

  pause() {
    this.audio.pause();
    this.isPlaying = false;
    this._notify();
  }

  toggle() {
    if (this.isPlaying) this.pause();
    else this.play();
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.songs.length;
    this._loadCurrent();
    this.play();
  }

  prev() {
    this.currentIndex = (this.currentIndex - 1 + this.songs.length) % this.songs.length;
    this._loadCurrent();
    this.play();
  }

  seek(time) {
    this.audio.currentTime = time;
    this._notify();
  }

  setVolume(vol) {
    this.audio.volume = vol;
    this._notify();
  }

  _loadCurrent() {
    this.audio.src = this.songs[this.currentIndex].file;
    this.audio.load();
    this.isPlaying = false;
    this._notify();
  }

  getState() {
    return {
      currentIndex: this.currentIndex,
      isPlaying: this.isPlaying && !this.audio.paused,
      currentTime: this.audio.currentTime,
      duration: this.audio.duration,
      volume: this.audio.volume,
      song: this.songs[this.currentIndex],
    };
  }

  getSongs() {
    return this.songs;
  }
}

// Khởi tạo service với danh sách bài hát
const songs = [
  {
    title: 'Hope To See You Again',
    artist: 'Antent',
    file: require('../Songs/hopeToSeeYouAgain.m4a'),
  },
  {
    title: 'Snow Fall',
    artist: 'øneheart x reidenshi',
    file: require('../Songs/snowFall.m4a'),
  }
];

const playerService = new PlayerService(songs);

export default playerService; 